import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "workplace-selector",
    template: require('./workplace-selector.component.html')
})
export class WorkplaceSelectorComponent {
    @Input()
    workplaces: Nema.Crew.Model.Workplace[];

    selected: Nema.Crew.Model.Workplace;

    @Input()
    get selectedWorkplace() {
        return this.selected;
    }

    @Output()
    selectedWorkplaceChange = new EventEmitter<Nema.Crew.Model.Workplace>();

    set selectedWorkplace(val) {
        this.selected = val;
        this.selectedWorkplaceChange.emit(this.selected);
    }

    @Input()
    isLoading = false;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/daily-activities/workplace-selector.component.ts